module.exports = __webpack_public_path__ + "img/star.c33ef190.svg";